/**
 * Experiment: talk to the Business NXT editor over postMessage instead of encoding the
 * session into the iframe URL. Kept free of any dependency on DocumentEditor.component.
 */

export const BNXT_APPLICATION_NAME = "Visma Business Cloud";

export const BNXT_EDITOR_URL = "https://business.stag.visma.net/features/feature-vbuc-17633/approval";

// MessageEvent.origin is only scheme://host, so the check has to be against the origin and not the full url
export const BNXT_EDITOR_ORIGIN = new URL(BNXT_EDITOR_URL).origin;

// A JWS is three base64url segments.
const JWS_PATTERN = /^[\w-]+\.[\w-]+\.[\w-]+$/;

export interface BnxtEditRequest {
    companyId: string;
    systemId: string;
    userId: string;
    readonly: boolean;
    administrator: boolean;
    taskId: number | string | null;
}

export interface BnxtOpenTaskMessage {
    command: "openTask";
    approvalToken: string;
    editRequest: BnxtEditRequest;
    requestId: string;
}

/**
 * The backend hands us the editor url with the signed edit request already substituted into it
 * (`https://business.stag.visma.net/approval/<jws>`). That trailing path segment is the approval token.
 */
export function extractApprovalToken(editorUrl: string | null | undefined): string | null {
    const path = editorUrl?.split(/[?#]/)[0] ?? "";
    const token = path.substring(path.lastIndexOf("/") + 1);

    return JWS_PATTERN.test(token) ? token : null;
}

// Experiment diagnostics; drop once the handshake is confirmed.
export const BNXT_LOG_PREFIX = "[bnxt-open-task]";

// The exact key Business NXT announces itself with isn't pinned down yet, so accept the plausible ones.
export function isEditorReadyMessage(data: any): boolean {
    return data === "ready"
        || data?.event === "ready"
        || data?.command === "ready"
        || data?.type === "ready"
        || data?.status === "ready";
}

export function buildOpenTaskMessage(approvalToken: string, editRequest: BnxtEditRequest): BnxtOpenTaskMessage {
    return {
        command: "openTask",
        approvalToken,
        editRequest,
        requestId: crypto.randomUUID()
    };
}
